<template>
  <AdminModal :title="`Agregar administrador · ${park.name}`" @close="$emit('close')">
    <p class="ad-note">
      El nuevo administrador recibirá una invitación por correo para crear su contraseña y tendrá acceso total al parque.
      Para relevar al anterior, agrega al nuevo y después suspende la cuenta del anterior desde Usuarios.
    </p>
    <form @submit.prevent="submit">
      <div class="ad-field">
        <label for="aa-name">Nombre</label>
        <input id="aa-name" v-model="name" class="ad-input" autocomplete="off" />
      </div>
      <div class="ad-field">
        <label for="aa-email">Correo</label>
        <input id="aa-email" v-model="email" type="email" class="ad-input" autocomplete="off" />
      </div>
      <div class="ad-field">
        <label for="aa-pass">Tu contraseña de superadmin</label>
        <input id="aa-pass" v-model="password" type="password" class="ad-input" autocomplete="current-password" />
      </div>
    </form>
    <p v-if="error" class="ad-error">{{ error }}</p>
    <template #footer>
      <button type="button" class="ad-btn ad-btn--ghost" @click="$emit('close')">Cancelar</button>
      <button type="button" class="ad-btn ad-btn--primary" :disabled="busy || !name.trim() || !email.trim() || !password" @click="submit">
        {{ busy ? 'Agregando…' : 'Agregar y enviar invitación' }}
      </button>
    </template>
  </AdminModal>
</template>

<script setup>
import { ref } from 'vue'
import AdminModal from './AdminModal.vue'
import { addParkAdmin } from '@/services/superadmin'
import { errorText } from './adminFormat'

const props = defineProps({ park: { type: Object, required: true } })
const emit = defineEmits(['close', 'done'])

const name = ref('')
const email = ref('')
const password = ref('')
const busy = ref(false)
const error = ref('')

async function submit() {
  if (busy.value || !name.value.trim() || !email.value.trim() || !password.value) return
  busy.value = true
  error.value = ''
  try {
    const res = await addParkAdmin(props.park.id, { name: name.value.trim(), email: email.value.trim(), password: password.value })
    emit('done', res)
  } catch (err) {
    error.value = errorText(err)
    busy.value = false
  }
}
</script>